/* eslint camelcase:0 */
import { unstable_createMuiStrictModeTheme } from '@material-ui/core';

import { theme as defaultTheme } from './default';

export const theme = unstable_createMuiStrictModeTheme(defaultTheme);
